import type { AuthState, OktaAuth } from '@okta/okta-auth-js';

import { createContext } from 'react';

import type { SportybotGroup } from './permissions/permissions';

export interface AuthContextValue {
  authClient: OktaAuth;
  authState: AuthState;
  user: OktaUser;
}

export interface OktaUser {
  email: string;
  firstName: string;
  groups: SportybotGroup[];
  id: string;
  lastName: string;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
